package one.healthium.rateus.data

import androidx.compose.runtime.Composable
import one.healthium.base.launcher.LocalPlatformLauncher
import one.healthium.base.sender.EmailSender
import one.primehealth.app.BaseAppConfig
import org.koin.compose.koinInject

@Composable
fun ComposeFeedbackEmail() {
    val appConfig = koinInject<BaseAppConfig>()
    val platformLauncher = LocalPlatformLauncher.current
    EmailSender.sendEmail(
        platformLauncher = platformLauncher,
        email = appConfig.feedbackEmail,
        subject = "App feedback"
    )
}

@Composable
expect fun RateApp()